<template>
    <transition name="fadeBg">
        <responsive-image
            class="absolute w-full h-full object-cover"
            :image="{ srcset:srcset, url:src }"
            :fallback-image="fallbackImage"
            :alt="alt"
        />
    </transition>
</template>

<script>
import ResponsiveImage from '@web/components/ResponsiveImage';

export default {
  components: {
    ResponsiveImage,
  },
  props: {
    srcset: {
      type: String,
      required: true,
    },
    src: {
      type: String,
      required: true,
    },
    fallbackImage: {
      type: String,
      required: false,
      default: '',
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style scoped>
</style>
